import React, { Component } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { fetchNavi, switchLang } from '../../redux/actions';
import LangWrapper from '../../components/LangWrapper';
import { fetchMenu, fetchDate } from '../../redux/actions';
import slug from 'slug'
import SmoothParallax from 'smooth-parallax';
import smoothScroll from 'smoothscroll'

import SubNav from '../../components/SubNav';

import './Header.css';
import './MobileNav.css';

export const scroll = (target) => {
  smoothScroll(document.querySelector(target), 500)
}

class Header extends Component {
  constructor(props){
    super(props)
    this.state = {
      navigationOpen: false,
      menuOpen: false
    }
  }

  componentDidMount() {
    const locale = this.props.intl.locale;

    this.props.fetchDate();

    if (!this.props.navi) {
      this.props.fetchNavi(locale);
    }

    if (!this.props.menus.length) {
      this.props.fetchMenu(this.props.date, locale);
    }

    window.addEventListener('load', SmoothParallax.init({
      basePercentageOn: 'pageScroll',
    }));
  }

  handleNavToggle() {
    if(this.state.navigationOpen) {
      this.setState({
        navigationOpen: false
      })
    }
    else {
      // if(window.innerWidth <= 767) {
        this.setState({
          navigationOpen: true
        })
      // }
    }
  }

  handleMenu() {
    if(this.state.menuOpen) {
      this.setState({
        menuOpen: false
      })
    }
    else {
      this.setState({
        menuOpen: true
      })
    }
  }

  onSwitchLang() {
    this.props.switchLang();
    window.location.reload();
  }

  render() {
    const isItemValid = (item, time) => {
      return (!item.fields.validFrom || new Date(time) >= new Date(item.fields.validFrom))
        && (!item.fields.validUntil || new Date(time) < new Date(item.fields.validUntil));
    }
    
    const {naviItems, menus, match} = {...this.props};
    const currentSlug = match.params.slug;
    const date = this.props.date;

    if(naviItems) {
      naviItems.forEach((item) => {
        const mainPage = item.mainPage || (item.childPages ? item.childPages[0] : null);
        let isCurrent = currentSlug === mainPage.fields.slug;
        if(item.childPages) {
          item.childPages.map(child => isCurrent = isCurrent || currentSlug === child.fields.slug);

        }
      })
    }

    return (
      <header className={currentSlug}>
        <Link to="/"><span className="logo" smooth-parallax="" end-movement="0.1" end-position-y="-0.05">Goldfish</span></Link>
        
        <Link to="/reservation" className="reservation">{this.props.intl.messages["general.bookTable"]}</Link>
        <Link to="/lahjakortti" className="giftcard">{this.props.intl.messages["general.giftCardButton"]}</Link>

        <LangWrapper onSwitch={() => this.onSwitchLang()} />

        <div className="header-some">
          <a href="https://www.facebook.com/Goldfish-Helsinki-288458664991654/" className="facebook">Facebook</a>
          <a href="https://www.instagram.com/goldfish_helsinki/" className="instagram">Instagram</a>
        </div>

        <span className="nav-toggle goldfish" onClick={this.handleNavToggle.bind(this)}><span /><span /><span /></span>
        <span className="nav-toggle" onClick={this.handleNavToggle.bind(this)}><span /><span /><span /></span>

        <nav className={'goldfish-mobile-nav ' + (this.state.navigationOpen ? 'open' : '')}>
          <span className="close" onClick={this.handleNavToggle.bind(this)} />

          <LangWrapper onSwitch={() => this.onSwitchLang()} />

          <div className="header-some">
            <a href="https://www.facebook.com/Goldfish-Helsinki-288458664991654/" className="facebook">Facebook</a>
            <a href="https://www.instagram.com/goldfish_helsinki/" className="instagram">Instagram</a>
          </div>
          <div className="navigation-wrapper">
	          {naviItems &&
	              naviItems.map((item, i) => {
	                const mainPage = item.mainPage || (item.childPages ? item.childPages[0] : null);
	                let isCurrent = currentSlug === mainPage.fields.slug;
	                let children;
	                if (item.childPages) {
	                  item.childPages.map(child => isCurrent = isCurrent || currentSlug === child.fields.slug);
	
	                  //if (isCurrent) {
	                  children = item.childPages;
	                  //}
	                }
	
	                return (
	                  <span key={`navilink_${i}`}>
	                    <a href={`/#${mainPage.fields.heading ? slug(mainPage.fields.heading.toLowerCase()) : ''}${(mainPage.sys.contentType.sys.id === 'contactUs') ? 'contact' : ''}`} onClick={this.handleNavToggle.bind(this)}>
	                      {item.label}
	                    </a>
	                    {children &&
	                      <SubNav
	                        onNav={() => this.handleNavToggle()}
	                        items={children.map(item => ({
	                          link: `/#${slug(item.fields.title ? item.fields.title.toLowerCase() : item.fields.heading.toLowerCase())}`,
	                          hidden: false,
	                          title: item.fields.title ? item.fields.title : item.fields.heading,
	                        })
	                        )} />
	                    }
	                    {(mainPage.fields.slug === 'menu' && currentSlug === 'menu') &&
	                      <SubNav
	                        onNav={() => this.handleNavToggle()}
	                        items={menus.map(item => {
	                          let link = `/menu/${slug(item.fields.title.toLowerCase())}`;
	
	                          if (item.fields.children) {
	                            const children = item.fields.children.filter(category => isItemValid(category, date));
	
	                            if (children) {
	                              link = `${link}/${slug(children[0].fields.title.toLowerCase())}`;
	                            }
	                          }
	                          return (
	                            {
	                              link: link,
	                              hidden: !item.fields.showInNavigation,
	                              title: item.fields.title,
	                            })
	                        }
	                        )} />
	                    }
	                  </span>
	                );
	              })
	            }
	         </div>
          <Link to="/lahjakortti" className="giftcard" onClick={this.handleNavToggle.bind(this)}>{this.props.intl.messages["general.giftCardButton"]}</Link>
        </nav>

        <nav className={'mobile-nav ' + (this.state.navigationOpen ? 'open' : '')}>
          <span className="close" onClick={this.handleNavToggle.bind(this)} />
          
          {naviItems &&
            naviItems.map((item, i) => {
              const mainPage = item.mainPage || (item.childPages ? item.childPages[0] : null);
              let isCurrent = currentSlug === mainPage.fields.slug;
              let children;
              if (item.childPages) {
                item.childPages.map(child => isCurrent = isCurrent || currentSlug === child.fields.slug);

                //if (isCurrent) {
                children = item.childPages;
                //}
              }

              return (
                <span key={`navilink_${i}`}>
                  <a href={`/#${mainPage.fields.heading ? slug(mainPage.fields.heading.toLowerCase()) : ''}${(mainPage.sys.contentType.sys.id === 'contactUs') ? 'contact' : ''}`} onClick={this.handleNavToggle.bind(this)}>
                    {item.label}
                  </a>
                  {children &&
                    <SubNav
                      onNav={() => this.handleNavToggle()}
                      items={children.map(item => ({
                        link: `/#${slug(item.fields.title ? item.fields.title.toLowerCase() : item.fields.heading.toLowerCase())}`,
                        hidden: false,
                        title: item.fields.title ? item.fields.title : item.fields.heading,
                      })
                      )} />
                  }
                  {(mainPage.fields.slug === 'menu' && currentSlug === 'menu') &&
                    <SubNav
                      onNav={() => this.handleNavToggle()}
                      items={menus.map(item => {
                        let link = `/menu/${slug(item.fields.title.toLowerCase())}`;

                        if (item.fields.children) {
                          const children = item.fields.children.filter(category => isItemValid(category, date));

                          if (children) {
                            link = `${link}/${slug(children[0].fields.title.toLowerCase())}`;
                          }
                        }
                        return (
                          {
                            link: link,
                            hidden: !item.fields.showInNavigation,
                            title: item.fields.title,
                          })
                      }
                      )} />
                  }
                </span>
              );
            })
          }
        </nav>
      </header>
    );
  }
}

Header.propTypes = {
  intl: intlShape.isRequired,
}

const mapStateToProps = state => ({
  naviItems: state.navi,
  menus: state.menus,
  date: state.date,
});

const mapDispatchToProps = {
  fetchNavi,
  fetchMenu,
  fetchDate,
  switchLang
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(Header)));



// WEBPACK FOOTER //
// ./src/containers/Header/Header.js